import { EventEmitter, Input, Output } from '@angular/core';
import { Component } from '@angular/core';
import { RatingRateEvent } from 'primeng/rating';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
})
export class RatingComponent {
  @Input() value!: number;
  @Input() stars = 5;
  @Input() readOnly: boolean = true;
  @Input() overRideClass: string = '';

  @Output() onRate = new EventEmitter();

  handleRate(event: RatingRateEvent) {
    this.onRate.emit(event);
  }
}
